// store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: { isLoading: false },
  reducers: {
    showLoader: (state) => { state.isLoading = true; },
    hideLoader: (state) => { state.isLoading = false; },
  },
});

export const { showLoader, hideLoader } = uiSlice.actions;
export default uiSlice.reducer;